import { render, staticRenderFns } from "./productDoc.vue?vue&type=template&id=28fe40cc&scoped=true"
import script from "./productDoc.vue?vue&type=script&lang=js"
export * from "./productDoc.vue?vue&type=script&lang=js"
import style0 from "./productDoc.vue?vue&type=style&index=0&id=28fe40cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fe40cc",
  null
  
)

export default component.exports